(ns teamoesterreich.admin-mode.user.user-card-dsg
  (:require
    [clojure.string]
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.util.date :as date-h]
    [teamoesterreich.util.helper :as h]
    [teamoesterreich.admin-mode.data.rights :as d-rights]
    [teamoesterreich.admin-mode.data.user :as d-user]
    [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
    [reagent-material-ui.icons.info :refer [info]]
    ))




(defn get-it [!actual-user !st]
  (let [!edit-mode (r/cursor !st [:edit])
        !edited (r/cursor !st [:edited])
        change-checkbox-fn (fn [key] (fn [e v] (js/console.log "click-checkbox-fn" e " v " v " ev " (h/event-value e)) (swap! !edited assoc key v)))
        actual-val-fn (fn [key & [def]] (h/coalesce (get @!edited key) (get @!actual-user key) def))
        changed-fn (fn [key] (not= (true? (actual-val-fn key)) (true? (get @!actual-user key))))

        !show-save (r/cursor !st [:show-save])]
    [mui/card {:style {:textAlign "left"}}
     [mui/card-header
      {:subheader "DSGVO Einstellungen des Teilnehmers"}]
     [mui/card-content

      [are-you-sure-modal/are-you-sure-modal !show-save
       (str "Willst du die Änderungen an diesem Teilnehmer `" (:user-firstName @!actual-user) " " (:user-lastName @!actual-user) "` wirklich speichern?")
       "Ok"
       (fn []
         (d-user/>user-edit-field (:user-uuid @!actual-user)
                                  (select-keys @!edited [:user-requestDeletion :user-datenOe3JaNein :user-infosJaNein :user-infosOe3JaNein])
                                  (fn []
                                    (reset! !edited {})
                                    (reset! !edit-mode false)
                                    ;(d-user/actual-user-invalidate !actual-user)
                                    ))
         )]

      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "flex-start"
        :alignItems "flex-start"
        :spacing    3
        :style      {:margin "0"}
        }


       [mui/grid
        {:container false :item true
         :xs        12                                      ;extra-small: 0px
         :style     {:padding "5px"}
         }
        [:h2 "Löschung"]
        [mui/form-group
         [mui/form-control-label
          {:style     {:paddingLeft "26px"}
           :label     "Löschung beantragt durch den Teilnehmer"
           :fullWidth true
           :control   (r/as-element
                        [mui/switch
                         {:checked  (or (get @!actual-user :user-requestDeletion) false)
                          :disabled true
                          }])}
          ]]]

       [mui/grid
        {:container false :item true
         :xs        12                                      ;extra-small: 0px
         :style     {:padding "5px"}
         }
        [:h2 "Online-Nennung"]
        [mui/form-group
         [mui/form-control-label
          {:style     {:paddingLeft "26px" :backgroundColor (if (changed-fn :user-datenOe3JaNein) "#ffd6d2" "#ffffff")}
           :label     (str "Online Nennung")
           :fullWidth true
           :control   (r/as-element
                        [mui/switch
                         {:disabled (not @!edit-mode)
                          :checked  (actual-val-fn :user-datenOe3JaNein)
                          :onChange (change-checkbox-fn :user-datenOe3JaNein)
                          }])}
          ]]



        [:h2 "Newsletter"]
        [mui/form-group
         [mui/form-control-label
          {:style     {:paddingLeft "26px" :backgroundColor (if (changed-fn :user-infosJaNein) "#ffd6d2" "#ffffff")}
           :label     "Newsletter des Österreichischen Roten Kreuzes"
           :fullWidth true
           :control   (r/as-element
                        [mui/switch
                         {:disabled (not @!edit-mode)
                          :checked  (actual-val-fn :user-infosJaNein)
                          :onChange (change-checkbox-fn :user-infosJaNein)
                          }])}
          ]]
        [mui/form-group
         [mui/form-control-label
          {:style     {:paddingLeft "26px" :backgroundColor (if (changed-fn :user-infosOe3JaNein) "#ffd6d2" "#ffffff")}
           :label     "Informationen von Ö3"
           :fullWidth true
           :control   (r/as-element
                        [mui/switch
                         {:disabled (not @!edit-mode)
                          :checked  (actual-val-fn :user-infosOe3JaNein)
                          :onChange (change-checkbox-fn :user-infosOe3JaNein)
                          }])}
          ]]

        [:br]
        [:div
         (when (d-rights/is-superuser?)
           [:<>
            (if-not @!edit-mode
              [mui/button {
                           :style   {:color "orange"}
                           :variant "outlined"
                           :onClick #(reset! !edit-mode true)
                           } "Bearbeiten (Superuser)"]
              [:<>
               [mui/button {
                            :color    "secondary"
                            :variant  "contained"
                            :disabled (not (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user)))
                            :onClick  (fn []
                                        (reset! !edited {})
                                        (reset! !edit-mode false))
                            } "Abbrechen"]
               (when (reduce (fn [c [k v]] (or c (not= (get @!actual-user k) v))) false @!edited)
                 [mui/button {
                              :color    "primary"
                              :variant  "contained"
                              :disabled (not (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user)))
                              :onClick  #(reset! !show-save true)
                              } "Speichern"])

               ])])
         [:br]
         [info]
         [:span "Aus Datenschutzgründen können Admins diese Einstellungen nur deaktivieren!"
          [:br] "Im Fehlerfall kontaktiere " [:a {:href (str "mailto:" (txt/txt :core :support_email))} (txt/txt :core :support_email)]]
         ]
        ]

       ]

      ]]))